import Index from "../components/LibraryFiles/index.js";

const LibraryFiles = () => {
    return <Index />;
};

export default LibraryFiles;
